import { apiUrl } from "../../common/utils/apiUrl";

export function buildDownloadUrl(file: { id?: string }): string {
  const token = localStorage.getItem("access") ?? "";
  return apiUrl(
    `api/v1/management/files/${file.id}/download/?token=${encodeURIComponent(token)}`
  );
}
